import { Record as record } from 'immutable';

import config from '../../config';
import { construct, resolve } from '../../helpers/LinkMapper';
import ValidationMixin from '../ValidationMixin';
import validators from '../../validation';

import UserPreferences from './UserPreferences';

const customerTitles = config.get('customerTitles') || [];
const defaults = {
    title: customerTitles[0],
    firstNames: null,
    surname: null,
    email: null,
    password: null,
    phone: null,
    photocardId: null,
    source: null,
    referrer: null,
    isOver16: false,
    preferences: new UserPreferences(),
    acceptedTAndCs: false,
    isAmazonRegistration: false,
    autoDrOptedIn: false,
    autoDelayRepayApp: false,
    autoDelayRepayEmail: false,
};

class Registration extends record(defaults) {

    static fromJSON (json) {
        return construct(Registration, json, {
            preferences: resolve.as(UserPreferences)
        });
    }

    getSchema () {
        const brand = config.get('brand');
        const isSouthEastern = brand === 'southeastern';

        let schema = {
            title: validators.title(),
            firstNames: validators.name(2, isSouthEastern ? 24 : 50),
            surname: validators.name(2, isSouthEastern ? 24 : 50),

            email: validators.email(),

            password: this.isAmazonRegistration ? validators.optional() : validators.passwordCreate().required(),

            // acceptedTAndCs: validators.true().required()
        };

        if (this.preferences.isSomeSmsPrefSetToTrue()) {
            schema = Object.assign(schema, {
                phone: validators.phone().required()
            });
        }

        return schema;
    }

    getValue (property) {
        return property in defaults ? this[property] : null;
    }

    get fullTelephoneNumber () {
        return this.phone;
    }

    get fullName () {
        return [this.title, this.firstNames, this.surname].join(' ');
    }

    arePersonalDetailsValid() {
        return ['firstNames', 'surname', 'email', 'password'].every(
                fieldName => this.isFieldValid(fieldName)
            );
    }
}

Object.assign(Registration.prototype, ValidationMixin);

export default Registration;



// WEBPACK FOOTER //
// ./src/records/customer/Registration.js